/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { PortCache };
class PortCache {
    #map = new Map();
    reconcilePorts(incoming, existing) {
        if (!existing) {
            return this.createNewSnapshot(incoming);
        }
        throw new Error("Not implemented");
    }
    createNewSnapshot(incoming) {
        return {
            updated: incoming,
            changes: {
                input: toUpdates(incoming.inputs),
                output: toUpdates(incoming.outputs),
                side: toUpdates(incoming.side),
            },
        };
        function toUpdates(ports) {
            return {
                fixedChanged: ports.fixed,
                deleted: [],
                added: ports.ports,
                updated: [],
            };
        }
    }
    current(graphId, nodeId) {
        return this.#map.get(graphId)?.get(nodeId);
    }
    getChanges(graphId, nodeId, ports) {
        let graphPorts = this.#map.get(graphId);
        if (!graphPorts) {
            graphPorts = new Map();
            this.#map.set(graphId, graphPorts);
        }
        const nodePorts = graphPorts.get(nodeId);
        const { updated, changes } = this.reconcilePorts(ports, nodePorts);
        graphPorts.set(nodeId, updated);
        return changes;
    }
}
//# sourceMappingURL=port-cache.js.map